/* DayBasics warehouse page, V4 (cj-dbw-*): coupon copy, shop-by-colour filters, sort, show more, the colour strip, and quick view on the colour cards, the review cards and the hero photo. */
(function () {
  /* several dbw sections include this file; everything below binds once per page (filters, Show more, Copy, quick view) */
  if (window.dbwBooted) return;
  window.dbwBooted = true;
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    /* copy the code */
    document.querySelectorAll('.dbw-pc[data-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.dataset.copy;
        try { navigator.clipboard.writeText(t); } catch (e) {}
        b.textContent = 'Copied'; b.classList.add('dbw-done');
        setTimeout(function () { b.textContent = 'Copy'; b.classList.remove('dbw-done'); }, 1800);
      });
    });

    /* quick view: the stock Impulse modal, loaded on first hover / focus / touch (same loader as cj-ows-band).
       Shared by the colour cards and the review cards, so each product loads and binds its modal once.
       This file is included by several dbw sections, so the load map lives on window and each card is bound once. */
    var qvJobs = window.dbwQvJobs || (window.dbwQvJobs = {});
    function qvLoad(card) {
      var id = card.dataset.productId, handle = card.dataset.productHandle;
      if (qvJobs[id]) return qvJobs[id];
      if (!window.fetch || !window.theme || !theme.Modals || !theme.routes) return Promise.resolve(false);
      var url = (theme.routes.home + '/products/' + handle + '?view=modal').replace('//', '/');
      qvJobs[id] = fetch(url).then(function (r) { return r.text(); }).then(function (text) {
        var html = document.createElement('div'); html.innerHTML = text;
        var div = html.querySelector('.product-section[data-product-handle="' + handle + '"]');
        var holder = document.getElementById('QuickShopHolder-' + handle);
        if (!div || !holder) return false;
        holder.innerHTML = ''; holder.append(div);
        new theme.Modals('QuickShopModal-' + id, 'quick-modal-' + id);
        theme.sections.register('product', theme.Product, holder);
        if (theme.collapsibles) theme.collapsibles.init();
        var m = document.getElementById('QuickShopModal-' + id);
        if (m) m.dataset.dbwReady = '1';
        return true;
      }).catch(function () { return false; });
      return qvJobs[id];
    }
    function qvBind(card, wholeCard) {
      if (card.dataset.dbwQvBound) return;
      card.dataset.dbwQvBound = '1';
      var warm = function () { card.removeEventListener('mouseover', warm); card.removeEventListener('focusin', warm); card.removeEventListener('touchstart', warm); qvLoad(card); };
      card.addEventListener('mouseover', warm); card.addEventListener('focusin', warm); card.addEventListener('touchstart', warm, { passive: true });
      var triggers = [].slice.call(card.querySelectorAll('[data-dbw-qv]'));
      triggers.forEach(function (trigger) {
        trigger.addEventListener('keydown', function (evt) { if (evt.key === 'Enter' || evt.key === ' ') { evt.preventDefault(); trigger.click(); } });
        trigger.addEventListener('click', function (evt) {
          evt.stopPropagation();
          var m = document.getElementById('QuickShopModal-' + card.dataset.productId);
          if (m && m.dataset.dbwReady) return; /* the modal is built: the js-modal-open-* class opens it */
          evt.preventDefault();
          qvLoad(card).then(function (ok) {
            if (ok) { trigger.click(); }
            else { var fallback = trigger.getAttribute('href') || card.dataset.productUrl; if (fallback) window.location.href = fallback; }
          });
        });
      });
      /* review cards: a click anywhere on the card opens the same quick view */
      if (wholeCard && triggers[0]) {
        card.addEventListener('click', function (evt) { if (evt.target.closest('a, button')) return; triggers[0].click(); });
      }
    }
    document.querySelectorAll('.dbw-word[data-product-handle]').forEach(function (card) { qvBind(card, true); });
    document.querySelectorAll('.dbw-hero__ph[data-product-handle]').forEach(function (card) { qvBind(card, false); });

    /* shop all by colour */
    var shop = document.querySelector('.dbw-shop');
    if (shop) {
      var mq = window.matchMedia('(min-width:1000px)');
      var limDesk = parseInt(shop.dataset.showDesk, 10) || 8, limMob = parseInt(shop.dataset.showMob, 10) || 4;
      var LIMIT = function () { return mq.matches ? limDesk : limMob; };
      var sections = [].slice.call(shop.querySelectorAll('.dbw-cs'));
      var sortEl = shop.querySelector('.dbw-sort');
      function selected(name) { return [].slice.call(shop.querySelectorAll('input[name=' + name + ']:checked')).map(function (i) { return i.value; }); }
      function apply() {
        var sz = selected('dbw_size'), kd = selected('dbw_kind'), sort = sortEl ? sortEl.value : 'rank', total = 0, shown = 0;
        sections.forEach(function (s) {
          var grid = s.querySelector('.dbw-cgrid'), cards = [].slice.call(grid.querySelectorAll('.dbw-cc'));
          var ok = cards.filter(function (c) {
            var ks = c.dataset.kind, ss = (c.dataset.sizes || '').split(',');
            var kok = !kd.length || kd.indexOf(ks) > -1;
            var sok = !sz.length || sz.some(function (z) { return ss.indexOf(z) > -1; });
            return kok && sok;
          });
          var key = {
            rank: function (c) { return +c.dataset.rank; }, pct: function (c) { return -c.dataset.pct; }, save: function (c) { return -c.dataset.save; },
            price: function (c) { return +c.dataset.price; }, priced: function (c) { return -c.dataset.price; }, rating: function (c) { return -c.dataset.rating; }
          }[sort] || function (c) { return +c.dataset.rank; };
          ok.sort(function (a, b) { return key(a) - key(b) || (+a.dataset.rank) - (+b.dataset.rank); });
          cards.forEach(function (c) { c.classList.add('dbw-hid'); });
          ok.forEach(function (c) { grid.appendChild(c); });
          var lim = s.dataset.open ? ok.length : LIMIT();
          ok.forEach(function (c, i) { if (i < lim) c.classList.remove('dbw-hid'); });
          var btn = s.querySelector('.dbw-showmore');
          if (btn) {
            if (ok.length > LIMIT()) { btn.hidden = false; btn.textContent = s.dataset.open ? 'Show fewer' : 'Show ' + (ok.length - LIMIT()) + ' more in ' + s.dataset.colour; }
            else { btn.hidden = true; }
          }
          var cnt = s.querySelector('.dbw-cnt');
          if (cnt) { cnt.textContent = (sz.length || kd.length) ? ok.length + ' of ' + cards.length + ' match' : cards.length + ' styles'; }
          s.classList.toggle('dbw-empty', ok.length === 0);
          total += cards.length; shown += ok.length;
        });
        var note = shop.querySelector('.dbw-fnote');
        if (note) note.textContent = (sz.length || kd.length) ? shown + ' of ' + total + ' pieces match, kept in their colours.' : '';
      }
      shop.querySelectorAll('.dbw-fpanel input, .dbw-sort').forEach(function (i) { i.addEventListener('change', apply); });
      var clear = shop.querySelector('.dbw-fclear');
      if (clear) clear.addEventListener('click', function () { shop.querySelectorAll('.dbw-fpanel input').forEach(function (i) { i.checked = false; }); if (sortEl) sortEl.value = 'rank'; apply(); });
      var fw = shop.querySelector('.dbw-fwrap'), fb = shop.querySelector('.dbw-fbtn'), fd = shop.querySelector('.dbw-fdone');
      if (fw && fb) {
        fb.addEventListener('click', function () { fw.classList.toggle('dbw-open'); });
        if (fd) fd.addEventListener('click', function () { fw.classList.remove('dbw-open'); });
        document.addEventListener('click', function (e) { if (!fw.contains(e.target)) fw.classList.remove('dbw-open'); });
      }
      sections.forEach(function (s) {
        var b = s.querySelector('.dbw-showmore');
        if (b) b.addEventListener('click', function () { if (s.dataset.open) { delete s.dataset.open; s.scrollIntoView({ behavior: 'smooth', block: 'start' }); } else { s.dataset.open = '1'; } apply(); });
      });
      mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
      apply();
      /* the colour strip follows the colour in view */
      if ('IntersectionObserver' in window) {
        var moved = false; window.addEventListener('scroll', function () { moved = true; }, { passive: true });
        var io = new IntersectionObserver(function (es) {
          if (!moved) return;
          es.forEach(function (e) { if (e.isIntersecting) { shop.querySelectorAll('.dbw-jc').forEach(function (j) { j.classList.toggle('dbw-on', j.getAttribute('href') === '#' + e.target.id); }); } });
        }, { rootMargin: '-35% 0px -45% 0px', threshold: 0 });
        sections.forEach(function (s) { io.observe(s); });
      }

      shop.querySelectorAll('.dbw-cc[data-product-handle]').forEach(function (card) { qvBind(card, false); });
    }
  });
})();
